import type { Plugin } from 'vue';
import { setAppContext } from './app-context';

export const AppContextPlugin: Plugin = (app) => {
  setAppContext(app);
};
